/** Human-readable storage size for quota UI (binary units). */
export function formatStorageBytes(bytes) {
    const n = Math.max(0, bytes);
    if (n < 1024)
        return `${n} B`;
    const kb = n / 1024;
    if (kb < 1024)
        return `${kb < 10 ? kb.toFixed(1) : Math.round(kb)} KB`;
    const mb = kb / 1024;
    if (mb < 1024)
        return `${mb < 10 ? mb.toFixed(1) : Math.round(mb)} MB`;
    const gb = mb / 1024;
    return `${gb < 10 ? gb.toFixed(1) : Math.round(gb)} GB`;
}
